module.exports = __webpack_public_path__ + "media/app/assets/icon-frame-aff01715dbe17a3d234e9a7614b639dc.png";